import { render, staticRenderFns } from "./TournamentCardLoader.vue?vue&type=template&id=3fa61c52&functional=true&"
import script from "./TournamentCardLoader.vue?vue&type=script&lang=js&"
export * from "./TournamentCardLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports